import request from '@/utils/request'

const UmengpushApi = {
  /** 获取友盟推送配置 */
  getConfig(data, errorback) {
    return request._get('/shop/setting.umengpush/index', data, errorback)
  },
  /** 保存友盟推送配置 */
  saveConfig(data, errorback) {
    return request._post('/shop/setting.umengpush/save', data, errorback)
  },
  /** 测试推送给指定用户 */
  testSend(data, errorback) {
    return request._post('/shop/setting.umengpush/testSend', data, errorback)
  },
  /** 推送日志列表 */
  logs(data, errorback) {
    return request._get('/shop/setting.umengpush/logs', data, errorback)
  },
  /** 公告列表 */
  announcementList(data, errorback) {
    return request._post('/shop/setting.announcement/index', data, errorback)
  },
  /** 发布公告 */
  announcementPublish(data, errorback) {
    return request._post('/shop/setting.announcement/publish', data, errorback)
  },
  announcementEdit(data, errorback) {
    return request._post('/shop/setting.announcement/edit', data, errorback)
  },
  announcementDelete(data, errorback) {
    return request._post('/shop/setting.announcement/delete', data, errorback)
  },
}

export default UmengpushApi



// WEBPACK FOOTER //
// ./src/api/umengpush.js